var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M946 154L946 182",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 946.5,
    cy: 149.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M953.912 149.556C952.764 149.556 951.824 150.497 951.824 151.645C951.824 152.679 952.576 153.545 953.554 153.714V155.472C953.554 158.125 951.391 160.288 948.739 160.288C946.086 160.288 943.923 158.125 943.923 155.472V153.751C947.384 153.563 950.131 150.704 950.131 147.205V142.032C950.131 141.825 949.961 141.674 949.773 141.674H947.008V140.376C947.008 140.169 946.839 140.019 946.65 140.019C946.444 140.019 946.293 140.188 946.293 140.376V143.706C946.293 143.913 946.462 144.063 946.65 144.063C946.857 144.063 947.008 143.894 947.008 143.706V142.408H949.397V147.205C949.397 150.422 946.782 153.037 943.565 153.037C940.349 153.037 937.734 150.422 937.734 147.205V142.389H940.123V143.687C940.123 143.894 940.292 144.045 940.48 144.045C940.687 144.045 940.838 143.875 940.838 143.687V140.357C940.838 140.15 940.668 140 940.48 140C940.273 140 940.123 140.169 940.123 140.357V141.655H937.357C937.15 141.655 937 141.825 937 142.013V147.186C937 150.685 939.747 153.545 943.189 153.733V155.453C943.189 158.501 945.672 161.003 948.739 161.003C951.805 161.003 954.269 158.52 954.269 155.472V153.714C955.248 153.545 956 152.679 956 151.645C956 150.497 955.059 149.556 953.912 149.556ZM953.912 153.018C953.159 153.018 952.539 152.397 952.539 151.645C952.539 150.892 953.159 150.271 953.912 150.271C954.664 150.271 955.285 150.892 955.285 151.645C955.285 152.416 954.664 153.018 953.912 153.018Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital1);
export default __webpack_public_path__ + "static/media/hospital_1.028f21280f5cde24e4ee2a1d322fc562.svg";
export { ForwardRef as ReactComponent };